/**
 * Normalize all colors to be 6 digit so when comparing #000 and #000000, they will both end up in one group.
 * Logic: https://gomakethings.com/converting-a-color-from-a-three-digit-hexcolor-to-a-six-digit-hexcolor-with-vanilla-js/
 * @param {String} hexcolor A color to normalize.
 * @return {String}
 */
const normalizeHexColor = (hexcolor = '') => {
    const isGradient = hexcolor.match('url');

    if (isGradient) {
        return hexcolor;
    }

    const withHash = hexcolor.indexOf('#') === 0;
    const hexCode = hexcolor.replace(/^#/, '');

    return (hexCode.length === 3
        ? `${withHash ? '#' : ''}${hexCode.split('').map((hex) => hex + hex).join('')}`
        : hexcolor)
        .toUpperCase();
};

module.exports = normalizeHexColor;
